import { writable } from 'svelte/store';

export const Username = writable ({value: '', isValid: false, isDirty: false, ref: null });
export const FromPage = writable("");

// Transient, in-memory only: carries the password from a successful USO
// sign-in through the confirm-details (recreate) page so the user can be
// logged straight in afterwards instead of retyping credentials they just
// proved. Cleared by RecreateAccount immediately after the auto-login
// attempt; never persisted anywhere.
export const PendingLoginPassword = writable("");
export const changePasswordThrough = writable({});

export const currentPasswordThrough = writable({});

export const IsMobileVerified = writable({});
export const IsEmailValidated = writable({});
export const SecurityQuestions = writable({});
export const SecurityAnswers = writable({});

